import type { ListBuilderList } from '../../../types';
import { createStandardClientColumns } from '../columns';
import {
	CLIENT_MOBILE_CARD_CONFIG,
	DEFAULT_LIST_REQUIRED_FIELDS,
	createClientKanbanConfig,
} from '../shared';

/**
 * Prospecting list configuration
 * Leads in "Prospecting" lifecycle stage
 */
export const prospectingList: ListBuilderList = {
	id: 'prospecting-list',
	cacheTTL: 600000,
	name: 'Prospecting',
	type: 'default',
	active: true,
	bulkActionTemplate: 'clients',
	sortOrder: 2,
	filterRules: {
		// PD-17595 — by the stage's meaning, so a renamed stage keeps the tab working.
		lifecycleStageMeaning: {
			defaultValue: [{ id: 'lead', label: 'Lead' }],
			locked: true,
			hidden: true,
		},
		salespeople: {
			defaultValue: [],
			additionalValues: [
				{
					values: [{ id: 'ME', label: 'Me' }],
					applyIf: {
						type: 'group',
						joiner: 'AND',
						negated: false,
						children: [
							{ type: 'rule', action: 'clients:view:self', negated: false },
						],
					},
				},
				{
					values: [{ id: 'ME_ALTERNATE', label: 'Me (Alternate)' }],
					applyIf: {
						type: 'group',
						joiner: 'AND',
						negated: false,
						children: [
							{ type: 'rule', action: 'clients:view:self', negated: false },
						],
					},
					applyAsDefault: false,
				},
				{
					values: [{ id: 'null', label: 'Unassigned' }],
					applyIf: {
						type: 'group',
						joiner: 'AND',
						negated: false,
						children: [
							{
								type: 'rule',
								action: 'clients:view:unassigned',
								negated: false,
							},
						],
					},
					applyAsDefault: false,
				},
			],
			applyDefaultIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'clients:list:any', negated: true }],
			},
			boundedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'clients:list:any', negated: true }],
			},
		},
		leadOrCustomer: {
			defaultValue: [
				{
					id: 'Lead',
					label: 'Leads',
				},
			],
			locked: true,
			hidden: true,
		},
	},
	columns: createStandardClientColumns(),
	mobileCardConfig: CLIENT_MOBILE_CARD_CONFIG,
	description: 'Every account whose stage means Lead',
	defaultSortId: 'column-client-name-asc',
	requiredFields: DEFAULT_LIST_REQUIRED_FIELDS,
	kanbanConfig: createClientKanbanConfig(),
};
